/** Model selector — MUI Select showing model name, detail, and rate limit info. */

import { FormControl, InputLabel, MenuItem, Select, Typography, Box } from "@mui/material";

interface Choice {
  value: string;
  label: string;
  detail?: string;
}

interface Props {
  value: string;
  onChange: (value: string) => void;
  choices: Choice[];
  label?: string;
  helperText?: string;
}

export default function ModelSelector({ value, onChange, choices, label = "Model", helperText }: Props) {
  return (
    <FormControl fullWidth size="small">
      <InputLabel>{label}</InputLabel>
      <Select value={value} onChange={(e) => onChange(e.target.value)} label={label}>
        {choices.map((c) => (
          <MenuItem key={c.value} value={c.value}>
            <Box>
              <Typography variant="body2">{c.label}</Typography>
              {c.detail && (
                <Typography variant="caption" color="text.secondary">
                  {c.detail}
                </Typography>
              )}
            </Box>
          </MenuItem>
        ))}
      </Select>
      {helperText && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, ml: 1.5 }}>
          {helperText}
        </Typography>
      )}
    </FormControl>
  );
}
